import {useIntl} from 'react-intl'

import {getRoomDisplayName, type SearchOccupancy} from './getRoomDisplayName'

// TODO [sc-198186]: remove once RAA returns the translated room name.
/**
 * Name shown to the guest for a room on the accommodation page, see
 * `getRoomDisplayName`. The payment page reads the roomless version from `rl`
 * instead, because BoVio returns the real room name there.
 * @param roomName - Name as it arrives from RAA.
 * @param occupancy - Guests and rooms of the search.
 */
export const useRoomDisplayName = (
  roomName: string | null | undefined,
  occupancy: SearchOccupancy
): string => {
  const {formatMessage} = useIntl()

  return getRoomDisplayName(formatMessage, roomName, occupancy)
}
